import React from 'react';

function CourseContent({content}) {
    const descriptionWithBreaks = content.description
        .split('\n') // Разбиваем текст по символам "\n"
        .map((paragraph, index) => (
            <p key={index}>
                {paragraph.split('<br>').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </p>
        ));
    return (
        <div className="CourseContent">
            {/*<p className="course-number">Урок {content.id}</p>*/}
            <span className="course-name">{content.name}</span>
            <span className="course-description">{descriptionWithBreaks}</span>
        </div>
    )
}

export default CourseContent;